import React from "react";

const Media = () => {
  return <h1>Media Page</h1>;
};

export default Media;
